<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="home"></ion-back-button>
    </ion-buttons>
    <ion-title>Topic Search</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div padding class="search-container" *mobxAutorun>
    <p>Select by phase</p>
    <div style="display: flex; flex-wrap: wrap">
      <ion-button
        *ngFor="let phase of phases"
        [fill]="selectedPhase == phase.category ? 'solid' : 'outline'"
        (click)="togglePhase(phase)"
        color="primary"
      >
        <div>{{ phase.name }}</div>
      </ion-button>
    </div>

    <p>Select by tag</p>
    <div style="display: flex; flex-wrap: wrap">
      <ion-button
        [color]="selectedTag == tag.id ? 'secondary' : 'dark'"
        *ngFor="let tag of tagsStore.topTags"
        [fill]="selectedTag == tag.id ? 'solid' : 'outline'"
        (click)="toggleTag(tag)"
      >
        <div>{{ tag.name }}</div>
      </ion-button>
      <ion-button clear (click)="showMoreTags()">More...</ion-button>
    </div>
    <ion-select #tagSelect style="display: none" [(ngModel)]="selectedTag" (ionChange)="search()">
      <ion-select-option *ngFor="let tag of tagsStore.aTags" [value]="tag.id">{{ tag.name }}</ion-select-option>
    </ion-select>
  </div>
  <div style="margin: 5px; padding-top: 2em; text-align: left; font-size: small">
    <div *ngIf="postStore.filteredPosts">{{ postStore.filteredPosts.length }} results</div>
    <cdk-virtual-scroll-viewport [itemSize]="100" minBufferPx="500" maxBufferPx="1000">
      <div *ngFor="let post of postStore.filteredPosts">
        <post-card [post]="post"></post-card>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</ion-content>
